{
	"app_name": "Topicus Events",
	"update": "Update",
	"update_later": "Later",
	"update_available": "Update available",
	"update_available_description": "A new version of the Topicus Events app is available. Update now for the best experience.",
	"update_available_mandatory": "Update required",
	"update_available_mandatory_description": "You need to update the Topicus Events app to continue.",
	"update_available_version_text": "You are currently using version {{currentVersion}}. Version {{newVersion}} is available.",
	"archive_default_title": "Archive",
	"archive_empty_message": "Your archive is still empty. Past events will appear here.",
	"archive_search_placeholder": "Search for events",
	"archive_recent_events": "Recent events",
	"archive_other_events": "Other events",
	"message_default_title": "Messages",
	"message_empty_message": "You have no messages. Messages from events you have added will appear here.",
	"message_web_only_title": "App only",
	"message_web_only_message": "Messages do not work in a browser. Install the Topicus Events app for iOS or Android to receive them.",
	"qr_web_only_title": "App only",
	"qr_web_only_message": "Scanning a QR code only works in the app. Install the Topicus Events app for iOS or Android, or add the event using its code.",
	"message_search_placeholder": "Search",
	"message_no_results_title": "Unfortunately...",
	"message_no_results": "no results found",
	"error_default_subject": "Oops, something went wrong.",
	"error_default_message": "Please try again later",
	"error_try_again": "Try again",
	"error_fetch_event": "Something went wrong while fetching the event. Please try again.",
	"error_save_event": "Something went wrong while saving the event. Please try again.",
	"error_delete_event": "Something went wrong while deleting the event. Please try again.",
	"error_add_event": "This event does not exist or has not been published yet. Check the code with the organiser",
	"error_add_event_failed": "The event could not be added. Check your internet connection and try again.",
	"error_event_not_found_title": "Event not found",
	"error_event_not_found_message": "There is no published event with this code. Check the code, or ask the organiser whether the event has been published.",
	"error_favorite_toggle_failed": "Your like could not be saved. Check your connection and try again.",
	"error_favorites_load_failed": "We couldn't load your favorites. Refresh the list to load them again.",
	"error_favorites_unavailable_title": "Likes unavailable",
	"error_favorites_refresh": "Refresh the list to load the like status, then you can like again.",
	"error_event_in_list": "You've already added this event. You can find it on your home screen.",
	"error_image_load": "Image could not be loaded",
	"error_link_open_title": "Cannot open",
	"error_link_open_message": "This could not be opened. Would you like to copy it?",
	"error_open_phone_title": "Phone number cannot be opened",
	"error_open_email_title": "Email address cannot be opened",
	"error_open_link_title": "Link cannot be opened",
	"error_open_value_message": "We couldn't open {{value}}. Would you like to copy it?",
	"error_empty_email_subject": "Enter your email address",
	"error_empty_email_message": "To reset your password you must enter a valid email address",
	"error_user_not_found_subject": "User not found",
	"error_user_not_found_message": "No user was found with the provided email address",
	"error_invalid_credentials": "Email address and/or password is incorrect",
	"error_camera_permission": "Go to Settings > Topicus Events > Camera and allow the app to use your camera",
	"error_camera_roll_permission_ios": "Go to Settings > Topicus Events > Photos and allow the app access to your photo library",
	"error_camera_roll_permission_android": "Go to Settings > Topicus Events > Storage and allow the app to save items",
	"error_delete_event_offline": "An internet connection is required to delete an event.",
	"error_add_event_offline": "An internet connection is required to add an event.",
	"error_empty_event_code": "Please enter an event code!",
	"error_something_went_wrong": "Something went wrong",
	"error_try_again_later": "Please try again later!",
	"cancel_deadline_passed_title": "Unsubscribing no longer possible",
	"cancel_deadline_passed_message": "The cancellation deadline has passed. Please contact the organisation to unsubscribe.",
	"error_something_went_wrong_short": "Oops",
	"error_something_went_wrong_generic": "Something went wrong.",
	"notice_session_not_stored_title": "You stay logged in while this window is open",
	"notice_session_not_stored_embedded": "This browser keeps no data in a window embedded in another site. Open the app in a tab of its own to stay logged in.",
	"notice_session_not_stored": "This browser keeps no data, a private window for instance. Close the page and you will have to log in again.",
	"error_session_expired_title": "You have been logged out",
	"error_session_expired": "Your session has expired. Log in again to continue.",
	"error_no_connection": "Could not reach the server. Check your internet or try again later.",
	"error_server": "Something went wrong on the server. Please try again later.",
	"error_went_wrong_title": "Something went wrong",
	"error_return_to_home": "Return to the main menu and try again",
	"error_password_too_short_title": "Password too short",
	"error_password_too_short_message": "Your password must be at least 8 characters.",
	"error_passwords_not_matching_title": "Oops!",
	"error_passwords_not_matching_message": "Your passwords do not match. Please try again.",
	"error_passwords_not_matching_inline": "Your passwords do not match!",
	"error_invalid_email_inline": "Please enter a valid email address.",
	"error_feedback_missing_title": "Your feedback is missing!",
	"error_feedback_missing_message": "Please fill in at least the feedback field.",
	"error_empty_form": "You cannot submit an empty form",
	"error_required_fields": "Please fill in the required fields",
	"error_fill_field_above": "Please fill in the field above",
	"error_field_required": "This field is required",
	"error_event_full_title": "This event is full",
	"error_event_full_message": "All places are taken, registering is no longer possible.",
	"error_form_closed_title": "Unfortunately, this form is closed",
	"error_form_closed_message": "Would you like to make a change, unsubscribe, or subscribe? Please send an email to the organization with your request.",
	"error_form_contact_note": "Contact us if this is not desired",
	"error_form_login_required": "You must be logged in to fill in this form. Go to the home screen and log in or register via the settings.",
	"error_form_needs_connection": "You need an internet connection to fill in this form. Please try again once you are back online.",
	"error_form_load_failed": "Something went wrong while loading this form. Please try again.",
	"error_login_required_for_event": "You need to be logged in for this event. Log in to register.",
	"error_email_exists_title": "Email address already in use",
	"error_email_exists_message": "An account with this email address already exists. Log in, or reset your password if you no longer know it.",
	"error_fetch_gallery": "Something went wrong while fetching this gallery. Please try again.",
	"error_photo_permission_title": "Photos cannot be used",
	"error_photo_permission_message": "By denying this permission, photos from your device cannot be used.",
	"error_camera_not_available_title": "Camera cannot be used",
	"error_camera_not_available_message": "By denying this permission, photos cannot be taken.",
	"success_saved_subject": "Saved!",
	"success_photo_saved": "The photo has been added to your album",
	"success_register_subject": "Registration successful!",
	"success_register_message": "Thank you for registering!",
	"success_login_subject": "Great!",
	"success_login_message": "You are logged in!",
	"success_welcome_default": "Welcome!",
	"success_welcome_named": "Welcome {{name}}!",
	"success_edit_profile_subject": "Profile updated!",
	"success_edit_profile_message": "We have updated your profile.",
	"success_password_reset_subject": "Password changed!",
	"success_password_reset_message": "Log in now with your new password.",
	"success_password_forgot_subject": "Check your email",
	"success_password_forgot_message": "If an account exists for this email address, you will receive an email to reset your password.",
	"success_uploaded_title": "Uploaded!",
	"success_uploaded_message": "The image has been uploaded!",
	"success_feedback_title": "Thanks for your feedback",
	"success_feedback_message": "We will get to work on it!",
	"success_form_received_title": "Received",
	"success_form_received_message": "The form has been received!",
	"success_unsubscribed_title": "Done",
	"success_unsubscribed_message": "You have been unsubscribed!",
	"success_password_changed": "Password changed successfully",
	"success_downloaded_title": "Downloaded",
	"success_downloaded_message_ios": "The image has been downloaded and can be found in your photos.",
	"success_downloaded_message_android": "The image has been downloaded and can be found in your gallery.",
	"success_downloaded_message_web": "The download has started. You will find the photo in your browser downloads.",
	"label_first_name": "First name",
	"label_last_name": "Last name",
	"label_email": "Email address",
	"label_email_android": "Email address",
	"label_password": "Password",
	"label_password_repeat": "Repeat password",
	"label_new_password": "New password",
	"label_new_password_repeat": "Repeat new password",
	"label_your_name": "Your name",
	"label_the_feedback": "The feedback",
	"label_video_player": "Video",
	"label_map": "Map",
	"placeholder_first_name": "Your first name",
	"placeholder_first_name_short": "First name",
	"placeholder_last_name": "Your last name",
	"placeholder_last_name_short": "Last name",
	"placeholder_email": "Your email address",
	"placeholder_email_short": "Email address",
	"placeholder_email_android": "Email address",
	"placeholder_password": "The password for your account",
	"placeholder_password_min_chars": "Your password, at least 8 characters",
	"placeholder_password_repeat": "Repeat the password for your account",
	"placeholder_password_short": "Password",
	"placeholder_password_repeat_short": "Repeat password",
	"placeholder_your_name": "Your name",
	"placeholder_feedback": "Your feedback",
	"placeholder_feedback_short": "Feedback",
	"placeholder_choose_option": "Choose an option",
	"placeholder_search": "Search",
	"placeholder_event_code": "Access code for the event",
	"button_login": "Login",
	"button_register": "Register",
	"button_register_lower": "register",
	"button_save": "Save",
	"button_submit": "Submit",
	"button_change_password": "Change password",
	"button_forgot_password": "Forgot password?",
	"button_maybe_later": "Maybe later",
	"button_send_email": "Send email",
	"button_cancel": "Cancel",
	"button_continue": "Continue",
	"button_open": "Open",
	"button_view_program_part": "View programme part",
	"label_choice_info": "Info",
	"button_favorite": "Favourite",
	"button_program_view_list": "List",
	"button_program_view_blocks": "Block schedule",
	"text_participants_of": "{{taken}} / {{limit}} participants",
	"error_too_many_attempts": "You have tried too often just now. Wait a minute and try again.",
	"text_choice_not_possible": "These do not go together",
	"text_max_choices": "You may pick {{count}} at most. Remove one first.",
	"text_day_full": "You may pick {{count}} for {{day}}. Remove one first.",
	"text_overlaps": "This session runs at the same time as {{other}}, so you can pick only one of them.",
	"text_choice_full": "Full",
	"text_seats_left_one": "1 place left",
	"text_seats_left_other": "{{count}} places left",
	"maps_open_title": "Open Google Maps",
	"maps_open_message": "You'll leave the app to open this location in Google Maps.",
	"maps_choose_message": "You'll leave the app to open this location. Choose where to view the route.",
	"button_ok": "OK",
	"button_oke": "OK",
	"button_copy": "Copy",
	"button_save_changes": "SAVE CHANGES",
	"button_submit_upper": "SUBMIT",
	"button_cancel_upper": "CANCEL",
	"button_add_upper": "ADD",
	"button_navigate_location_upper": "NAVIGATE TO LOCATION",
	"button_add": "Add",
	"button_delete_upper": "DELETE",
	"button_cancel_delete_upper": "CANCEL",
	"tab_home": "Home",
	"tab_archive": "Archive",
	"tab_messages": "Messages",
	"tab_photos": "Photos",
	"tab_settings": "Settings",
	"title_settings": "Settings",
	"title_login_or_register": "Login or register",
	"title_welcome": "Welcome",
	"title_feedback": "Give feedback",
	"title_contact": "Contact",
	"title_profile": "Profile",
	"title_edit_profile": "Edit profile details",
	"title_forgot_password": "Forgot password",
	"title_change_password": "Change password",
	"title_register": "Register",
	"title_qr_scanner": "Scan QR code",
	"title_photos": "Photos",
	"title_form_closed": "Form closed",
	"title_my_timetable": "My personal program",
	"text_login_description": "With a user account, events are linked to your account. This way you always have access to your favorite events!",
	"text_change_password_description": "Choose a new password of at least 8 characters.",
	"text_email_not_editable": "Your email address can't be changed.",
	"text_email_from_account": "This is the email address of your account. Your confirmation with QR code will be sent to this address.",
	"text_no_internet": "You have no internet connection, so some features of the app may not work properly.",
	"text_scan_qr_instruction": "Point your camera at the event's QR code",
	"text_form_login_description": "A user account is required for this form. We can link data such as access tickets to your new Topicus Events account, so you always have your entrance pass at hand!",
	"text_forgot_password_description": "No problem. Enter your email address and we will send you instructions to reset your password.",
	"text_home_has_events": "Tap an event to open it.",
	"text_home_no_events": "You have not yet added a Topicus event. Press add event, scan or enter the code to gain access.",
	"text_add_event": "Add event",
	"text_no_photos_title": "No photos available",
	"text_no_photos_message": "Add an event to view associated photos.",
	"text_gallery_empty": "This gallery does not contain any images yet.",
	"text_feedback_helper": "With the help of your feedback we can improve the app. If we need more explanation about the feedback, we can contact you.",
	"text_profile_subtitle": "Edit your profile details",
	"text_receive_notifications": "Receive notifications",
	"text_receive_notifications_helper": "Receive push notifications about changes and news for your events.",
	"text_give_feedback": "Give feedback",
	"text_version_number": "Version number",
	"text_privacy_policy": "Privacy policy",
	"url_privacy_policy": "https://topicusevents.nl/privacy-statement",
	"url_topicus": "https://www.topicus.nl",
	"text_contact_topicus": "Topicus",
	"text_contact_address": "Singel 25",
	"text_contact_postal": "7400 AH Deventer",
	"text_set_profile_photo": "Set profile photo",
	"text_choose_profile_photo": "Choose profile photo",
	"text_upload_photo": "Upload photo",
	"text_galleries": "Galleries",
	"text_hindered_question": "Are you unable to attend? ",
	"text_unsubscribe": "Unsubscribe",
	"text_delete_account": "Delete account",
	"alert_access_event_title": "Access to the event",
	"alert_access_event_message": "To access the event, a QR code must be scanned or a code must be entered manually.",
	"alert_login_required_title": "Login required",
	"alert_login_required_message": "Log in to add an event. This keeps your participation linked to your account.",
	"alert_login_required_view_message": "Log in to view this event. This keeps your participation linked to your account.",
	"alert_event_already_added_title": "Event already added",
	"alert_scan_qr": "Scan QR",
	"alert_enter_code": "Enter code",
	"alert_event_code_title": "Code for the event",
	"alert_event_code_message": "Enter the code to gain access.",
	"alert_add_event_title": "Add event",
	"alert_add_event_description": "Enter the access code of the event to add the event.",
	"alert_add_event_confirm_message": "You are about to add this event. Do you want to continue?",
	"alert_add_photo_title": "Add photo",
	"alert_add_photo_message": "This will add a photo to {{name}}",
	"alert_open_camera": "Open camera",
	"alert_open_camera_roll": "Open camera roll",
	"alert_logout_title": "Log out",
	"alert_logout_message": "Are you sure you want to log out?",
	"alert_logged_out_title": "Logged out",
	"alert_logged_out_message": "You have been logged out because you recently changed your password.",
	"alert_delete_account_title": "Delete account",
	"alert_delete_account_message": "You are about to delete your account. Do you want to continue?",
	"alert_delete_account_confirm": "Delete",
	"alert_delete_account_final_title": "Are you sure?",
	"alert_delete_account_final_message": "This cannot be undone. Your account and data will be permanently deleted.",
	"alert_account_deleted_title": "Account deleted",
	"alert_account_deleted_message": "Your account has been deleted.",
	"alert_delete_event_title": "Delete event?",
	"alert_delete_event_message": "Deleting an event cannot be undone. Are you sure you want to delete it?",
	"alert_unsubscribe_title": "Unsubscribe",
	"alert_unsubscribe_message": "Are you sure you want to unsubscribe?",
	"alert_new_notification": "New notification",
	"button_delete": "Delete",
	"button_close": "Close",
	"button_edit": "Edit",
	"button_done": "Done",
	"title_subscribe": "Subscribe",
	"text_have_account": "Already have an account? ",
	"text_no_account": "No account yet? ",
	"text_register_link": "Register",
	"day_sunday": "Sunday",
	"day_monday": "Monday",
	"day_tuesday": "Tuesday",
	"day_wednesday": "Wednesday",
	"day_thursday": "Thursday",
	"day_friday": "Friday",
	"day_saturday": "Saturday",
	"day_unknown": "Unknown",
	"title_news": "News",
	"title_choose_gallery": "Choose gallery",
	"text_choose_gallery_description": "Tap one of the galleries below to upload a photo to it.",
	"text_no_favorites_for_day": "You have no favourites for this day.",
	"text_no_activities_in_timetable": "There are no activities in your personal timetable yet. Tap the heart next to an activity name to add it to your timetable.",
	"text_no_gallery_data": "No gallery data available",
	"text_extra_information": "Extra information",
	"text_no_results_found": "No results found.",
	"text_no_news_title": "No news",
	"text_no_news_message": "No news has been posted yet.",
	"text_no_food_title": "Nothing on offer",
	"text_no_food_message": "No food and drinks have been added yet.",
	"text_no_locations_title": "No locations",
	"text_no_locations_message": "No locations have been added yet.",
	"text_no_program_title": "No programme",
	"text_no_program_message": "No programme is available yet.",
	"text_no_timetable_title": "No timetable",
	"text_no_timetable_message": "No timetable is available yet.",
	"text_no_galleries_title": "No galleries",
	"text_no_galleries_message": "No galleries are available yet.",
	"text_no_content_title": "No content",
	"text_no_content_message": "This page has no content yet.",
	"text_no_map_title": "No map",
	"text_no_map_message": "No map is available yet.",
	"text_error_prefix": "Error",
	"button_back": "Back",
	"title_my_submission": "My registration",
	"title_programs": "Programmes",
	"title_day_number": "Day {{number}}",
	"my_submission_banner_title": "My registration",
	"my_submission_banner_subtitle": "View your QR code for entry",
	"my_submission_helper": "Show this QR code at the entrance.",
	"my_submission_registration_label": "Registration number",
	"my_submission_programme_title": "Your programme",
	"my_submission_empty_title": "No registration",
	"my_submission_empty_message": "You have no registration for this event.",
	"my_submission_error_title": "Something went wrong",
	"my_submission_error_message": "We couldn't load your registration. Please try again later.",
	"on_behalf_question": "Who is this registration for?",
	"on_behalf_self": "I am registering myself",
	"on_behalf_other": "I am registering someone else",
	"on_behalf_logged_in_as": "Logged in as {{name}} ({{email}})",
	"on_behalf_email_hint": "The confirmation with QR code is sent to the email address you enter below.",
	"on_behalf_success_message": "The registration has been sent to {{email}}.",
	"on_behalf_list_title": "Registered by you",
	"on_behalf_cancel_message": "Are you sure you want to unregister {{name}}? {{name}} will receive a confirmation.",
	"on_behalf_cancelled_message": "{{name}} has been unregistered."
}
